<template>
    <div>
        <b-row class="pb-2">
            <b-col>
                <app-detalhe titulo="Status do Item" :xl="xl">
                    <strong>{{ item.descStatus }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Tipo de Faturamento" :xl="xl">
                    <strong>{{ item.descTipoFaturamento }}</strong>
                </app-detalhe>
                <!-- <app-detalhe titulo="Natureza do item" :xl="xl">
                    <strong>{{ item.descNatureza }}</strong>
                </app-detalhe> -->
                <app-detalhe titulo="Tipo Produto" :xl="xl">
                    <strong>{{ item.descTipoProduto }}</strong>
                </app-detalhe>
                <!-- <app-detalhe titulo="Unidade" :xl="xl">
                    <strong>{{ item.descUnidade }}</strong>
                </app-detalhe> -->
                <app-detalhe titulo="Quantidade" :xl="xl">
                    <strong>{{ item.quantidade }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Valor unitario" :xl="xl">
                    <strong>{{ item.valorUnitario | currency }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Desconto" :xl="xl">
                    <strong>{{ item.desconto }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Descrição" :xl="xl">
                    <strong>{{ item.descricao }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Descricao Resumida" :xl="xl">
                    <strong>{{ item.descricaoResumida }}</strong>
                </app-detalhe>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: () => {}
        }
    },
    
    data() {
        return {
            xl: 2,
        }
    },

    methods: {
    },

    created() {
    },
    
}

</script>

<style>

</style>